<section class="system">
    <div class="section-name">
        <h6>Turbo-charge your existing system</h6>
        <div class="line"></div>
    </div>
    <div class="system-wrapper">
        <div class="system-text">
            <p>
                WorldERP® offers highly customizable COTS and custom solutions for a variety of industries and missions.
                Our solutions are built upon three core principles: Maximizing Productivity; Information Security Compliance, and;
                Ease of Use, and are built to exacting specifications and compliance requirements.<br/><br/>
                Maximized productivity is achieved through our proprietary blend of hyperconvergence,
                hyperautomation, Artificial Intelligence (AI), intelligent workflows, and our simple to use interfaces
                that are wizard-driven to nearly eliminate training requirements and promote ease of use for superior user adoption.<br/><br/>
                Whether you want to modernize and turbo-charge the efficiency of your existing ERP or Financial Accounting system or
                replace your existing technology, WorldERP® provides solutions for the core functions of a variety of industries.
                <br/><br/>
                <b>Turbo-charge your existing ERP or Financial Accounting system:</b>
            </p>
        </div>

        <div (click)="clickValueItem($event)" class="system-items">
            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/Deltek.png" alt="Deltek logo">
                        </div>
                        <h6 class="value-item-title">Deltek</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Deltek</h5>
                            <p>WorldERP® provides solutions for those businesses that are struggling with certain features of Deltek. After all,
                                replacing or upgrading to the next Deltek product is a significant capital expense.<br/><br/>
                                WorldERP® solutions will allow your existing Deltek system to be more agile, productive, cost effective, and user friendly.</p>
                                <ul>
                                    <li>Modernizes and updates user interfaces, ease of use, and ability to customize.</li>
                                    <li>Reduces maintenance costs.</li>
                                    <li>Streamline front AND back office processes by improved user friendly interfaces that eliminate errors with seamless integration between
                                        financials, contract management and ecommerce.</li>
                                </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/Epicor.png" alt="Epicor logo">
                        </div>
                        <h6 class="value-item-title">Epicor</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Epicor</h5>
                            <p>WorldERP® enables Epicor customers to turbo-charge their legacy system to provide the features of a true cloud platform.</p>
                            <ul>
                                <li>Streamline front AND back office processes by improved user friendly interfaces that eliminate errors with seamless integration between
                                    financials, contract management and ecommerce.</li>
                                <li>Improves ease of use and ability to customize.</li>
                                <li>Reduces the need for complicated and costly maintenance.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/intacct.png" alt="Intacct logo">
                        </div>
                        <h6 class="value-item-title">Intacct</h6>
                    </div>
                    <div class="value-item-pop-up third">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Intacct</h5>
                            <p>WorldERP® provides solutions for those businesses that are struggling with certain features of Inacct. After all,
                                replacing or upgrading to the next Inacct product is a significant capital expense.<br/><br/>
                                WorldERP® solutions will allow your existing Inacct system to be more agile, efficient, productive, and cost effective.</p>
                            <ul>
                                <li>Adds better eCommerce and PO functionality.</li>
                                <li>Adds improved AR functionality.</li>
                                <li>Reduces training time and cost.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/Lawson.png" alt="Lawson logo">
                        </div>
                        <h6 class="value-item-title">Lawson</h6>
                    </div>
                    <div class="value-item-pop-up fourth">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Lawson</h5>
                            <p>WorldERP® provides solutions for those businesses that are struggling with certain features of Lawson. After all,
                                replacing or upgrading to the next Lawson product is a significant capital expense.<br/><br/>
                                WorldERP® solutions will allow your existing Lawson system to be more agile, efficient, productive, and cost effective.</p>
                                <ul>
                                    <li>Improves ease of use and ability to customize.</li>
                                    <li>Adds better eCommerce and PO functionality.</li>
                                    <li>Reduces training time and cost.</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/Microsoft.png" alt="Microsoft logo">
                        </div>
                        <h6 class="value-item-title">Microsoft</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Microsoft</h5>
                            <p>WorldERP® provides Microsoft users with less cost and more user friendly solutions to dramatically reduce cost of ownership.</p>
                            <ul>
                                <li>Dramatically reduces training difficulty and requirements.</li>
                                <li>Reduces the number of clicks to perform a task.</li>
                                <li>Reduces training time and cost.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/oracle.png" alt="Oracle logo">
                        </div>
                        <h6 class="value-item-title">Oracle</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Oracle</h5>
                            <p>Are you tired of needing a consultant for every software update or change in business procedures/requirements?<br/>
                                Do you need to expand to encompass additional territories?<br/><br/>
                                The answer to saving big money is a multi-tier ERP model powered by WorldERP®. Our multi-tier model lets you preserve your
                                existing investments in Oracle while expanding functionality by equipping global entities with a more agile,
                                flexible cloud-based ERP/financials system using our proprietary Colony™ solution and giving headquarters the real-time visibility it needs.</p>
                            <ul>
                                <li>Allows entities to maintain their own financial accounting structure that suites their specific needs.</li>
                                <li>Dramatically reduces training difficulty and requirements.</li>
                                <li>Allows for localized commerce, documents, and compliance requirements.</li>
                                <li>Provides mobile capabilities.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/Quickbooks.png" alt="QuickBooks logo">
                        </div>
                        <h6 class="value-item-title">QuickBooks</h6>
                    </div>
                    <div class="value-item-pop-up third">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>QuickBooks</h5>
                            <p>WorldERP® solutions enable QuickBooks customers to transform their business by expanding QuickBooks features and functionality.
                                Manage your business end-to-end with one integrated business suite for all of your core processes. 
                                </p>
                                <ul>
                                    <li>No more cumbersome restrictions brought on by limited account code formats and length.</li>
                                    <li>No more juggling of separate software applications and wasting time and resources maintaining and upgrading various software applications.</li>
                                    <li>Allows medium and larger size businesses to leverage features and lower cost of QuickBooks.</li>
                                </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/Sage.png" alt="Sage logo">
                        </div>
                        <h6 class="value-item-title">Sage</h6>
                    </div>
                    <div class="value-item-pop-up fourth">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Sage</h5>
                            <p>WorldERP® provides solutions for those businesses that are struggling with certain features of Sage. After all,
                                replacing or upgrading to the next Sage product is a significant capital expense.<br/><br/>
                                WorldERP® solutions will allow your existing Sage system to be more agile, efficient, productive, and cost effective.</p>
                                <ul>
                                    <li>Dramatically reduces training difficulty and requirements.</li>
                                    <li>Streamline front AND back office processes by eliminate errors with seamless integration between financials,
                                        contract management and ecommerce.</li>
                                    <li>Improves ease of use and ability to customize.</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/SAP.png" alt="SAP logo">
                        </div>
                        <h6 class="value-item-title">SAP</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>SAP</h5>
                            <p>If you could afford SAP and all the other capital expenses that came along with it, you may have been a happy camper when it was first
                                installed and configured but, if you need to add functionality or expanding your business, you know it’s going to cost you big. 
                                Maybe your company is growing with new subsidiaries, new acquisitions and new global markets, CHA-CHING. Maybe you need to integrate 
                                these new entities with your corporate ERP, CHA-CHING. Maybe you want to…CHA-CHING, CHA-CHING, and CHA-CHING.<br/><br/>
                                WorldERP® provides solutions let you preserve your existing investments in SAP while expanding functionality with our easier
                                to use and less costly alternatives that are more agile, flexible, and cloud-based and can leverage our proprietary Colony™ 
                                solution to provide the power you need for multiple, even global territories while giving headquarters the real-time visibility it needs.</p>
                                <ul>
                                    <li>Dramatically reduces training difficulty and requirements.</li>
                                    <li>Improves ease of use and ability to customize.</li>
                                    <li>Allows entities to maintain their own financial accounting structure that suites their specific needs.</li>
                                    <li>Allows for localized commerce, documents, and compliance requirements.</li>
                                </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/system/OtherLegacy.png" alt="Other Legacy Systems">
                        </div>
                        <h6 class="value-item-title">Other Legacy Systems</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Aerospace</h5>
                            <p>WorldERP® enables customers to turbo-charge their legacy system to provide the features of a true cloud platform.</p>
                            <ul>
                                <li>Streamline front AND back office processes by improved user friendly interfaces that eliminate errors with seamless integration
                                    between financials, contract management and ecommerce.</li>
                                <li>Improves ease of use and ability to customize.</li>
                                <li>Reduces the need for complicated and costly maintenance.</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>     
</section>